import { Box, makeStyles } from '@material-ui/core';
import { ArrowRightAlt } from '@material-ui/icons';
import { Spinner } from 'react-bootstrap';
import themes from 'styles/themes';
export interface IButtonContinueProps {
    handleClick?: any;
    isDisabled?: boolean;
    content: string;
    isHiddenArrow?: boolean;
    loading?: boolean;
}
export const useStyles = makeStyles((theme) => ({
    continueContainer: {
        position: 'absolute',
        bottom: 10,
        width: '100%',
        left: 0,
        maxWidth: 500,
        margin: 'auto',
        right: 0,
        padding: '0 24px',
    },
    continue: {
        width: '100%',
        height: 44,
        padding: 0,
        fontSize: 14,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        border: 'none',
        color: themes.palette.common.white,
    },
}));
export default function ButtonContinue({
    handleClick,
    isDisabled,
    content,
    isHiddenArrow,
    loading,
}: IButtonContinueProps) {
    const classes = useStyles();
    return (
        <Box className={classes.continueContainer}>
            <button
                className={classes.continue}
                onClick={handleClick}
                type="submit"
                color="primary"
                style={{
                    textDecoration: 'none',
                    backgroundColor: !isDisabled ? themes.palette.primary.main : '#A3A3A3',
                }}
                disabled={isDisabled}
            >
                {content} {!isHiddenArrow && <ArrowRightAlt />}{' '}
                {loading && <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />}
            </button>
        </Box>
    );
}
